import { isElement, setNodes } from '@udecode/plate-core';
import { withNodeId as withPlateNodeId } from '@udecode/plate-node-id';
import { v4 as uuidv4 } from 'uuid';
import { DreamWithOverride } from '../../plate';

export const withNodeId: DreamWithOverride = (editor, plugin) => {
  const e = withPlateNodeId(editor, {
    ...plugin,
    options: {
      idKey: 'id',
      idCreator: uuidv4,
      filterText: true,
      filter: () => true,
      ...plugin.options,
    },
  });

  const { normalizeNode } = e;

  e.normalizeNode = (entry) => {
    const [node, path] = entry;
    if (isElement(node) && !node.id) {
      setNodes(
        editor,
        { id: uuidv4() },
        { at: path },
      );
      return;
    }

    normalizeNode(entry);
  };

  return e;
};
